import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Gallery", to: "/gallery" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location.pathname]);

  const transparent = location.pathname === "/" && !scrolled;

  return (
    <header
      data-testid="site-navbar"
      className={`site-navbar ${transparent ? "is-transparent" : "is-solid"}`}
    >
      <div className="container-shell navbar-inner">
   <Link to="/" data-testid="navbar-brand-link" className="brand-block">
  <img
    src="/logo.png"
    alt="Wayne Iron Works Logo"
    style={{ height: "190px" }}
  />
</Link>

        <nav data-testid="desktop-nav" className="desktop-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`desktop-nav-${item.label.toLowerCase()}-link`}
              className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact#quote-form" data-testid="navbar-request-quote-button" className="primary-btn nav-cta">
            Request a Quote
          </Link>
        </nav>

        <button
          type="button"
          data-testid="mobile-menu-toggle-button"
          className="mobile-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <div data-testid="mobile-nav-wrapper" className={`mobile-nav ${menuOpen ? "is-open" : ""}`}>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`mobile-nav-${item.label.toLowerCase()}-link`}
            className={({ isActive }) => `mobile-nav-link ${isActive ? "is-active" : ""}`}
          >
            {item.label}
          </NavLink>
        ))}
        <Link to="/contact#quote-form" data-testid="mobile-request-quote-button" className="primary-btn mobile-nav-cta">
          Request a Quote
        </Link>
      </div>
    </header>
  );
};
